export default function imgCropUrl(imageUrl: string, isDevice: boolean) {
  // Default stock check
  if (imageUrl.match(/stockimages/g)) {
    return isDevice ? `${imageUrl}?width=660` : imageUrl;
  }

  // Actual images
  return isDevice
    ? `${imageUrl}?trim=0.08&width=660&smart`
    : `${imageUrl}?trim=0.08&width=1729&smart`;
}
